module.exports = __webpack_public_path__ + "static/media/galdinsPlayed_100000_250000.b2be7871.png";